// removed by extract-text-webpack-plugin
module.exports = {"BreakpointFromMedium":"(min-width: 640px)","S-50":"#EAE9FF","stepContent":"G60573b","headingWrapper":"G7c2e36","secondaryBoxButton":"Gf03e41"};